/**
 * Utility functions for detecting and handling numeric field types
 * based on Unit.title from SSQ properties
 */

export enum NumberType {
    PERCENTAGE = "percentage",
    PHYSICAL_UNIT = "physical_unit",
    NON_NUMERIC = "non_numeric",
}

/**
 * Determines the specific number type based on unit title
 */
export function getNumberType(unitTitle?: string): NumberType {
    if (!unitTitle) return NumberType.NON_NUMERIC;

    const title = unitTitle.toLowerCase().trim();

    // Percentage types
    if (["%", "percentage", "percent"].includes(title)) {
        return NumberType.PERCENTAGE;
    }

    // Everything else with a unit is treated as physical unit (kg, m, l, etc.)
    return NumberType.PHYSICAL_UNIT;
}

/**
 * Determines the number of decimal places to show based on number type
 */
export function getDecimalPlaces(numberType: NumberType): number {
    switch (numberType) {
        case NumberType.PERCENTAGE:
        case NumberType.PHYSICAL_UNIT:
        case NumberType.NON_NUMERIC: // = no unit given; the value can still be a number
            return 2; // Default for decimal and physical units
        default:
            return 0;
    }
}

/**
 * Checks if grouping separators (thousands) should be used
 */
export function shouldUseGrouping(numberType: NumberType): boolean {
    // Generally use grouping for all numeric types except percentages
    return numberType !== NumberType.PERCENTAGE;
}
